import * as toggleHandler from './toggleHandler';
import * as rubyLLMPipeline from '../ruby_llm/pipeline';
import { fetchChatkitConversation } from './apiRoutes';

const RUBY_LLM_MODE = 'ruby_llm';

let widgetInitialized = false;
let activePipeline = null;

export function setupWidgetButtons() {
  toggleHandler.setup();
}

export function cleanupWidgetButtons() {
  toggleHandler.cleanup();
}

function _container() {
  return document.getElementById('chatkit-v2-widget-container');
}

function _pipelineFor(mode) {
  switch (mode) {
    case RUBY_LLM_MODE:
      return rubyLLMPipeline;
    default:
      return rubyLLMPipeline;
  }
}

function _mountSubscription(html) {
  const subscription = _container()?.querySelector('#chatkit-v2-subscription');
  if (subscription && html) subscription.innerHTML = html;
}

async function initializeWidget() {
  const conversation = await fetchChatkitConversation();
  if (!conversation) return;

  _mountSubscription(conversation.subscription_html);
  activePipeline = _pipelineFor(conversation.mode);
  activePipeline.activate({ aiChatId: conversation.ai_chat_id });

  widgetInitialized = true;
}

export function destroyWidgets() {
  if (activePipeline) activePipeline.deactivate();
  activePipeline = null;
  widgetInitialized = false;
}

document.addEventListener('chatkit-v2.toggle.open', async () => {
  if (!widgetInitialized) await initializeWidget();
});
